<script>
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
import PhxPicture from '@maison/components/common/PhxPicture.vue';

export default {
  components: {
    PhxPicture,
    PhxsgButton,
  },

  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    url: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    variationCount: {
      type: Number,
      required: true,
    },
    additionalClasses: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    getModelSinglePushClasses() {
      return ['single-push', ...this.additionalClasses];
    },
  },
};
</script>

<template>
  <div :class="getModelSinglePushClasses">
    <div class="single-push__column">
      <a :href="url" class="picture single-push__image">
        <PhxPicture lazy v-bind="image" style="pointer-events: inherit" />
      </a>
    </div>

    <div class="single-push__column">
      <div class="headings">
        <!-- TODO: migration: replace by the heading component -->
        <h2>{{ name }}</h2>

        <!-- TODO: migration: replace by the heading component -->
        <h3 class="headings__subtitle"></h3>
      </div>

      <div class="single-push__infos">
        {{ $t('Models.variationCount', { variations: variationCount }) }}
      </div>

      <phxsg-button use="a" :href="url" variant="secondary" class="single-push__cta">
        {{ $t('Models.discoverMore') }}
      </phxsg-button>
    </div>
  </div>
</template>
